import { render, staticRenderFns } from "./ModalRegisterCardManager.vue?vue&type=template&id=1926f65a&"
import script from "./ModalRegisterCardManager.vue?vue&type=script&lang=js&"
export * from "./ModalRegisterCardManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports